import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=2b8f8588&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=ts&"
export * from "./Step2.vue?vue&type=script&lang=ts&"
import style0 from "./Step2.vue?vue&type=style&index=0&id=2b8f8588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f8588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8f8588')) {
      api.createRecord('2b8f8588', component.options)
    } else {
      api.reload('2b8f8588', component.options)
    }
    module.hot.accept("./Step2.vue?vue&type=template&id=2b8f8588&scoped=true&", function () {
      api.rerender('2b8f8588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/Step2.vue"
export default component.exports